import api from "./api";
import { changeInBatches } from "../helpers/publicPhotoChanges";

class EventsService {
    publicUploads(id) {
        return api.get(`/event/${encodeURIComponent(id)}/public-uploads`);
    }

    // «Publicar evento» (galería pública + listado de la app): independiente de activar los selfies.
    setPublicGallery(id, active) {
        return api.put(`/event/${encodeURIComponent(id)}/public-gallery`, { active });
    }

    // Fotos visibles en la galería pública (dueño o colaborador aceptado), con su clave de origen.
    publicPhotos(id) {
        return api.get(`/event/${encodeURIComponent(id)}/public-photos`);
    }

    // Solo el dueño: publica fotos ya subidas o las quita de la galería sin borrarlas.
    publishPublic(id, photoKeys) {
        return changeInBatches(batch => api.post(`/event/${encodeURIComponent(id)}/public-photos`, { action: 'publish', photoKeys: batch }), photoKeys);
    }

    unpublishPublic(id, photoKeys) {
        return changeInBatches(batch => api.post(`/event/${encodeURIComponent(id)}/public-photos`, { action: 'unpublish', photoKeys: batch }), photoKeys);
    }

    deletePhotos(keys) {
        return api.post('/photos/delete', { keys });
    }

    getAll() {
        return api.get('/event');
    };

    createEvent(event) {
        return api.post('/event', event)
    };

    checkCodeAvailability(code) {
        return api.get(`/check-event-code-availability/${encodeURIComponent(code)}`);
    };

    updateEvent(event) {
        return api.post(`/event/${event.id}`, event)
    };

    announceComplete(id) {
        return api.post(`/event/${id}/announce-complete`)
    };

    getSharedWith(id) {
        return api.get(`/get-event-shared-with/${id}`)
    }

    editSharedWith(id, sharedWith) {
        return api.post(`/edit-event-shared-with/${id}`, sharedWith)
    }

    getEventSharedWithMe() {
        return api.get('/get-event-shared-with-me')
    }
    
    deleteEvent(id) {
        return api.delete(`/event/${id}`)
    };
}
// eslint-disable-next-line import/no-anonymous-default-export
export default new EventsService();
